'use strict';

import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { format, subDays, addDays } from 'date-fns';
import cn from 'classnames/bind';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { ordersSelectors, ordersOperations } from '@/state/domains/orders';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { assignmentsSelectors, assignmentsOperations } from '@/state/domains/assignments';
import { locationsSelectors } from '@/state/domains/locations';
import { getWeekStartFromRef } from '@/state/utilities';
import { getHistory } from '@/history';

import Link from '@/views/common/Link';
import DesktopHeader from '@/views/common/Header/Desktop';
import MobileHeader from '@/views/common/Header/Mobile';
import s from './styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		isMobile: appSelectors.isMobile(state, props),
		isMenuOpen: appSelectors.isRouterInProgress(state, props),
		location: appSelectors.getLocation(state, props),
		page: appSelectors.getPage(state, props),
		pageId: appSelectors.getPageId(state, props),
		pageUrl: appSelectors.getPageUrl(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		pageContext: appSelectors.getPageContext(state, props),
		user: usersSelectors.getPageUser(state, props),
		actionMode: appSelectors.getActionMode(state, props),
	}),
	{
		updateClientWidth: appOperations.updateClientWidth,
		setMenuOpen: appOperations.setMenuOpen,
		setMenuClose: appOperations.setMenuClose,
	}
)(
	({
		isMobile,
		isMenuOpen,
		location,
		page,
		pageId,
		pageUrl,
		pageContext,
		actionMode,
		toggleStats,
		toggleImport,
		urlParams,
		updateClientWidth,
		setMenuOpen,
		setMenuClose,
	}) => {

		const ref = useRef(null);

		useEffect(() => {

			let timeoutId = null;

			const resizeListener = () => {
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					updateClientWidth(ref.current.clientWidth);
				}, 150);
			};

			window.addEventListener('resize', resizeListener);

			resizeListener();

			return () => {
				window.removeEventListener('resize', resizeListener);
			};
		}, []);

		let header = isMobile ?
			<MobileHeader { ...urlParams } /> :
			<DesktopHeader { ...urlParams } />;

		return (
			<div
				className={
					sx(
						'root',
						{
							none: [
								'attempt',
								'serve',
								'badAddress',
								'deliver',
							].includes(actionMode)
						}
					)
				}
				ref={ ref }
			>
				{ header }
			</div>
		);
	}
);
